import { Component, OnInit } from '@angular/core';
import { TableMode } from 'src/app/components/grid/grid.component';
import { FieldDataType } from 'src/app/components/grid/FieldDataType';
import { QueryOperand } from 'src/app/components/grid/QueryOperand';
import { ITableData } from 'src/app/components/grid/ITableData';
import { IColumn } from 'src/app/components/grid/IColumn';
import { GridUtil } from 'src/app/components/grid/GridUtil';
import { EventService } from 'src/app/services/event-services/error-event.service';
import { ExamService } from 'src/app/services/exam-service.service';
import { ProctorService } from 'src/app/services/proctor.service';

@Component({
  selector: 'app-proctors',
  templateUrl: './proctors.component.html',
  styleUrls: ['./proctors.component.scss']
})
export class ProctorsComponent implements OnInit {

  gridName = 'proctorGrid';
  constructor(private examService: ExamService, private proctorService: ProctorService, private eventService: EventService) { }

  async ngOnInit() {
    GridUtil.setClearGridSelection();
    this.refreshData();
  }

  data: ITableData = {
    tableRows: [],
    tableParams: {
      filterParams: [
        {
          fieldName: 'examId',
          fieldValue: `${this.examService.selectedExamIds}`,
          queryOperand: QueryOperand['=='],
          static: false
        }
      ],
      sortParam: {
        fieldName: "",
        orderDirection: 0,
      },
      pageInfo: {
        previousPageSize: 50,
        page: 1,
        pageSize: 50,
        recordCount: 0,
        pageCount: 0
      },
      tableMode: TableMode.serverProcessing,
      selectAll: false
    }
  };

  columns: IColumn[] = [
    {
      fieldDataType: FieldDataType.text,
      fieldName: 'requestId',
      displayName: 'Proctor Request ID',
      searchable: true,
      orderable: true,

    },
    {
      fieldDataType: FieldDataType.text,
      fieldName: 'accessCode',
      displayName: 'Access Code',
      searchable: true,
      orderable: true,

    },
    {
      fieldDataType: FieldDataType.enum,
      fieldName: 'disabled',
      displayName: 'Disabled',
      searchable: true,
      orderable: true,

    },
    {
      fieldDataType: FieldDataType.text,
      fieldName: 'examName',
      displayName: 'Exam Name',
      searchable: true,
      orderable: true,

    }
  ]

  emitProctorData(idx: any) {
    if (!this.data?.tableRows) { //Just in case tableRows might still not be ready
      setTimeout(() => this.emitProctorData(idx), 50);
      return;
    }
    let storedIds = GridUtil.getSelectedDataID(this.gridName) ?? [];
    const selectedProctor: any[] = idx.map(x => this.data.tableRows[x]).filter(Boolean);
    let selectedDataRowsId = storedIds.length > 0 ? storedIds : selectedProctor.map(x => x.id);
    GridUtil.setRowCliclk(this.gridName, idx, selectedDataRowsId);
  }

  async refreshData() {
    const res = await this.proctorService.getExamProctors(this.data.tableParams) as [];
    if (!res || res.length === 0) {
      return;
    }
    this.data.tableRows = res.slice(1, res.length);
    this.data.tableRows = res.slice(1, res.length);
    setTimeout(() => {
      this.eventService.gridDataLoadedEvent.next(true);
    });
  }

}
